// Mensagem postada por integração externa pelo webhook de entrada por conversa
// (POST /api/v1/ingest/conversa, consoleai#25341). O backend grava o nome do token
// em `metadata.integracao` — é o que diz quem postou, já que não há autor.

export function nomeDaIntegracao(meta: Record<string, unknown> | null): string | null {
  const nome = meta?.integracao
  return typeof nome === 'string' && nome.trim() ? nome : null
}

// O texto da integração é multilinha (uma informação por linha) e usa CommonMark
// (`**negrito**`). Markdown junta `\n` simples num parágrafo só; `pre-wrap` puro
// preservaria as linhas mas mostraria os `**` crus. Quebra dura do CommonMark (dois
// espaços antes do `\n`) preserva as duas coisas. Linha só de espaços continua em
// branco, então o parágrafo entre blocos não muda.
export function comQuebrasDuras(texto: string): string {
  return texto.replace(/\r\n/g, '\n').replace(/ *\n/g, '  \n')
}
